'use client';
import React from 'react';

export const LearnSectionLabel: React.FC<{ label: string; className?: string }> = ({ label, className }) => {
  return (
    <div
      className={`text-[0.6875rem] font-semibold uppercase tracking-[0.12em] text-bzblue-500 ${className ?? 'mb-3'}`}
    >
      {label}
    </div>
  );
};
